import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './pages/App/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.scss';
import {Provider} from 'react-redux';
import {configureStore} from "@reduxjs/toolkit";

import shopSlice from './services/slices/ShopSlice'
import cartSlice from './services/slices/CartSlice'
import eventSlice from './services/slices/EventSlice'
import contactSlice from './services/slices/ContactSlice'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const store = configureStore({
    reducer: {
        shopSlice,
        cartSlice,
        eventSlice,
        contactSlice
    },
});

export type AppDispatch = typeof store.dispatch;

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>
);

